import React from 'react';
import { AdSpot } from '@domain-group/fe-co-allhomes-ads';
import { css } from '@emotion/core';
import { jsx as ___EmotionJSX } from "@emotion/core";
var adStyle = {
  name: "46b038",
  styles: "margin-top:30px;"
};
var MobileAdSpot = () => ___EmotionJSX(AdSpot, {
  css: adStyle,
  gpt: {
    adId: 'adspot-320x50-pos-1',
    strategy: 'immediate'
  },
  adbridg: {
    id: 'adb-ah-det-bottom',
    adClass: 'adb-ah-bottom'
  }
});
export default MobileAdSpot;